import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from "@angular/core";
import { Customer } from "../../../../objects/customers/customer";
import { ModalDirective } from "ngx-bootstrap";
import { NgForm } from "@angular/forms";
import { CustomerService } from "../../../../services/customerService";
import { BlurUtil } from "../../../../common/utils/blurUtil";
import { Router } from "@angular/router";
import * as ps from "perfect-scrollbar";
import { CustomerModifyRequest } from "../../../../objects/requests/customerModifyRequest";
import { ToastsManager } from "ng2-toastr";
import { ExtraDataService } from "../../../../services/extraDataService";
import { ReferenceType } from "../../../../objects/extraData/extraDataSearchRequest";
import { ExtraData } from "../../../../objects/extraData/extraData";
import { BaseExtraData } from "../../../extraData/baseExtraData";
import { OrderViewType } from "../../../../objects/management/order/orderViewType";
import { UserViewHelper } from "../../../../common/helpers/userViewHelper";
import { UserViewService } from "../../../../services/userViewService";
import { Component as ComponentEnum } from "../../../../objects/components/component";
import { EmailTemplateType } from "../../../../objects/email/emailTemplateType";
import { EmailService } from "../../../../services/emailService";
import { User } from "../../../../objects/users/user";
import { PaymentService } from "../../../../services/paymentService";
import { PaymentEmailRequest } from "../../../../objects/email/PaymentEmailRequest";
import { StorageManager } from "../../../../common/managers/storageManager";
import { CargoWiseOrganization } from "../../../../objects/customers/cargo-wise-organization";
import { ConfigService } from "../../../../services/configService";
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { fromPromise } from "rxjs/observable/fromPromise";
import { finalize } from "rxjs/operators";
import { PaymentCompany } from "../../../../objects/payment/paymentCompany";
import { StripePaymentData } from "../../../../objects/customers/stripe-payment-data";

/**
 * Created by alex.y on 9/7/2017.
 */
@Component({
    selector: 'customer-modal',
    templateUrl: 'customerModal.component.html',
    moduleId: module.id.toString()
})
export class CustomerModalComponent extends BaseExtraData implements OnInit {
    @ViewChild('customerModal')
    public customerModal: ModalDirective;

    @ViewChild('paymentProcessModal')
    public paymentProcessModal: ModalDirective;

    @ViewChild("customerForm")
    public customerForm: NgForm;

    public originalCustomer: Customer = new Customer();
    public currentCustomer: Customer = new Customer();

    public string = String;
    public number = Number;
    public title: string;

    public processing: boolean = false;

    public changeCustomersForAll: boolean = false;

    @Output()
    public customerSaved: EventEmitter<Customer> = new EventEmitter();

    private top: number = 10;
    private skip: number = 3;
    private hasNextOrder: boolean = true;

    public isOrderLoading: boolean = false;

    @Input()
    public idToBlur: string;

    public extraData: ExtraData = new ExtraData();

    public tableColumns: any[] = [];
    public cardRequestLoader: boolean = false;
    public sentText: boolean = false;
    public updateRequestSent: boolean = false;
    public orderId: number;
    public showProcessPaymentBtn: boolean = false;
    public showUpdatePaymentDataBtn: boolean = false;
    public showSendCcRequestExistingCustomerBtn: boolean = false;
    public paymentSeccess: boolean = false;
    public paymentErrorMsg: string;
    public showbigModal: boolean = false;
    public paymentData: any = {FileNumber: "", Amount: "", CurrencyCode: ""};
    public showLoader: boolean = false;
    public CcError: boolean = false;
    public CurrencyCode: string;
    public currentUser: User;

    public cwOrganization: string = '';
    public select2CwOrganizationData: any = null;
    public paymentCompany: PaymentCompany = PaymentCompany.None;
    public cargoWise: boolean;
    public nexGen: boolean;
    public newCustomer: boolean;
    public existingCustomer: boolean;

    @ViewChild("paymentProcessForm")
    public paymentProcessForm: NgForm;

    @ViewChild('customerModalRef') customerModalRef: ElementRef;
    @ViewChild('paymentProcessModalRef') paymentProcessModalRef: ElementRef;
    @ViewChild('amount') amount: ElementRef;

    public isEditMode: boolean;
    // TEMP FOR TEST BY TASK https://jira.ak-tech.org/browse/BB-2852
    public isDisabledSendGetStartedEmailButton$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public customerPaymentLink$: BehaviorSubject<string> = new BehaviorSubject<string>('');
    public isCopied$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    constructor(public customerService: CustomerService,
                private router: Router,
                public toastr: ToastsManager,
                public cdr: ChangeDetectorRef,
                public extraDataService: ExtraDataService,
                public userViewService: UserViewService,
                private emailService: EmailService,
                private storageManager: StorageManager,
                private paymentService: PaymentService,
                private configService: ConfigService) {
        super(extraDataService);
    }

    public changeCCode() {

        if (this.CurrencyCode == undefined) {
            this.CcError = true;
        } else {
            this.CcError = false;
        }
        this.cdr.detectChanges();
    }

    public processPayment(isValid: boolean):void{

        this.changeCCode();

        this.showLoader = true;

        if (this.CcError) {
            console.log("CcError")
            this.showLoader = false;
            return;
        }
            
        if (!isValid) {
            console.log("valid")
            this.showLoader = false;
            return;
        }

        var am = this.replase(this.amount.nativeElement.value);
        this.paymentData.Amount = am;

        var fn: string = this.paymentData.FileNumber.trim();

        this.paymentService.pay(fn, am, this.CurrencyCode, this.currentCustomer.Id, this.currentUser.Id, null, this.currentCustomer.StripePaymentData != null ? this.currentCustomer.StripePaymentData.PaymentCompany : PaymentCompany.CargoWise).then(result  =>{

            this.showbigModal = true;
            this.paymentSeccess = true;

        }, reject => {

            this.showbigModal = true;
            this.paymentErrorMsg = reject.Data.Message;
        });
    }

    private replase (str: any){
        return str.replace(/\,/g, "").replace("$", "").trim();
    }

    public async show(customerId?: number): Promise<void> {
        if (customerId) {
            this.isEditMode = true;
            this.title = 'Edit Customer';

            const customer = (await this.customerService.getCustomerById(customerId)).Data;
            this.originalCustomer = customer;
            this.currentCustomer = JSON.parse(JSON.stringify(customer));
            this.showProcessPaymentBtn = this.currentCustomer.StripePaymentData != null;
            this.showUpdatePaymentDataBtn = this.currentCustomer.StripePaymentData != null;
            this.showSendCcRequestExistingCustomerBtn = this.currentCustomer.StripePaymentData == null;
            this.cargoWise = this.currentCustomer.StripePaymentData == null || this.currentCustomer.StripePaymentData.PaymentCompany == PaymentCompany.CargoWise || this.currentCustomer.StripePaymentData.PaymentCompany == PaymentCompany.None;
            this.nexGen = this.currentCustomer.StripePaymentData && this.currentCustomer.StripePaymentData.PaymentCompany == PaymentCompany.NexGen;
            this.paymentCompany = this.cargoWise ? PaymentCompany.CargoWise : PaymentCompany.NexGen;
            this.newCustomer = true;
            this.customerModal.show();

            this.hasNextOrder = true;

            this.skip = customer.Orders.length;

            let tempExtraData = await this.getExtraData(customerId.toString(), ReferenceType.Order);

            if (tempExtraData)
                this.extraData = tempExtraData;
            else {
                this.extraData = new ExtraData();

                this.extraData.ReferenceId = customerId.toString();
                this.extraData.ReferenceType = 0;
                this.extraData.Name = "marketing text";
            }

            BlurUtil.blurMenu(this.idToBlur);

            this.tableColumns = UserViewHelper.getColumns(this.userViewService, ComponentEnum.OrderManagement, OrderViewType.Tile);
            this.updatePaymentLink();
        } else {
            this.isEditMode = false;
            this.title = 'Add Customer';

            this.customerModal.show();
            BlurUtil.blurMenu(this.idToBlur);
            this.tableColumns = UserViewHelper.getColumns(this.userViewService, ComponentEnum.OrderManagement, OrderViewType.Tile);
        }
    }

    public showProcessPaymentModal(): void {
        this.paymentProcessModal.show();
    }

    public updatePaymentData(): void {
        let request = new PaymentEmailRequest({
            EmailType: EmailTemplateType.UpdatePaymentData,
            OrderId: "",
            CustomerId: this.currentCustomer.Id,
            AgentUserId: this.currentUser.Id,
            PaymentCompany: this.currentCustomer.StripePaymentData != null ? this.currentCustomer.StripePaymentData.PaymentCompany : PaymentCompany.CargoWise
        });

        this.emailService.sendPaymentEmail(request).then(resp => {
            if (resp.Success) {
                this.updateRequestSent = true;
            }
        })
    }

    public changePaymentType(type: number): void {
        if(this.currentCustomer.StripePaymentData == null)
            this.currentCustomer.StripePaymentData = new StripePaymentData();
        if(type == 1) {
            this.nexGen = false;
            this.currentCustomer.StripePaymentData.PaymentCompany = PaymentCompany.CargoWise;
            this.paymentCompany = PaymentCompany.CargoWise;
        }
        else if(type == 2){
            this.cargoWise = false;
            this.currentCustomer.StripePaymentData.PaymentCompany = PaymentCompany.NexGen;
            this.paymentCompany = PaymentCompany.NexGen;
        }
        this.updatePaymentLink();
    }

    public changeCustomerType(type: number): void {
        if(type == 1)
            this.existingCustomer = false;
        if(type == 2)
            this.newCustomer = false;
        if (this.existingCustomer) {
            setTimeout(() => {
                this.initCwOrganizationCodeSelect2();
            }, 200);
        }
        this.updatePaymentLink();
    }

    public sendToNewCustomer(): void{
        //this.cardRequestLoader = true;

        let request = new PaymentEmailRequest({
            EmailType: EmailTemplateType.CreditCardRequest,
            OrderId: "",
            CustomerId: this.currentCustomer.Id,
            AgentUserId: this.currentUser.Id,
            PaymentCompany: this.paymentCompany
        });


        this.emailService.sendPaymentEmail(request).then(resp => {
            if(resp.Success){
                this.cardRequestLoader = false;
                this.sentText = true;
            }
        })
    }

    public sendToExistingCustomer(): void{
        let request = new PaymentEmailRequest({
            EmailType: EmailTemplateType.CreditCardExistingCustomerRequest,
            OrderId: "",
            CustomerId: this.currentCustomer.Id,
            AgentUserId: this.currentUser.Id,
            CargoWiseOrganizationCode: this.cwOrganization,
            PaymentCompany: this.paymentCompany
        });

        this.emailService.sendPaymentEmail(request).then(resp => {
            if(resp.Success){
                this.cardRequestLoader = false;
                this.sentText = true;
                $('#cwOrganizationSelect').html("");
            }
        });
    }
    
    private initCwOrganizationCodeSelect2(): void {
        let self = this;
        let selectElement = $('#cwOrganizationSelect');
        let cw1ConnectorUrl = this.configService.config.CW1ConnectorUrl;
        let cw1ConnectorKey = this.configService.config.CW1ConnectorKey;
        selectElement.select2({
            width: '100%',
            data: [],
            allowClear: true,
            selectOnClose: true,
            placeholder: 'Select CW1 organization',
            ajax: {
                url: `${cw1ConnectorUrl}?key=${cw1ConnectorKey}`,
                dataType: "json",
                delay: 500,
                data: function (params: any) {
                    return {
                        org_name: params.term
                    };
                },
                processResults: function (data: { Organizations: CargoWiseOrganization[] }, params: any) {
                    let results: any[] = data.Organizations.map((x) => ({
                            id: x.OrganizationCode,
                            text: `${x.OrganizationName} (${x.OrganizationCode})`,
                            Item: x
                        }));
                    return {
                        results: results
                    };
                },
            },
            minimumInputLength: 3
        }).on('select2:select', function (e: any) {
            let selectedData = $(this).select2('data');
            self.cwOrganization = selectedData[0].id;
            self.updatePaymentLink();
            self.select2CwOrganizationData.trigger("select", { data: { item: selectedData[0].Item, text: selectedData[0].text, id: selectedData[0].id } });
        }).on('select2:unselect', function (e: any) {
            self.cwOrganization = '';
            self.updatePaymentLink();
        }).on('select2:open', function (params: any) {
            let select = $(this).data("select2");
            select.results.clear();
            select.dropdown._resizeDropdown();
            select.dropdown._positionDropdown();
        });
        
        this.select2CwOrganizationData = selectElement.data("select2");
    }

    public async ngOnInit(): Promise<void> {
        ps.initialize(this.customerModalRef.nativeElement);
        this.currentUser = await this.storageManager.getCurrentUser();

      this.updatePaymentLink();
    }

    private updatePaymentLink(): void {
        const templateType = this.existingCustomer ? EmailTemplateType.CreditCardExistingCustomerRequest : EmailTemplateType.CreditCardRequest;
        let link = `${location.origin}/orderpayment/?email=${this.currentCustomer.Email}&c=${this.currentCustomer.Id}&emailtype=${templateType}&an=${this.currentUser.Id}&pp=0&paycom=${this.paymentCompany}`

        if (!String.isNullOrEmpty(this.cwOrganization)) {
            link += `&cwoc=${this.cwOrganization}`;
        }

        this.customerPaymentLink$.next(link);
    }

    public onPaymentProcessModalHidden(): void{

        this.paymentData.FileNumber= '';
        this.paymentData.Amount = '';
        this.paymentErrorMsg = '';
        this.showbigModal = false;
        this.paymentSeccess = false;
        this.showLoader = false;

    }

    public onModalHidden(): void {
        this.customerForm.reset();
        BlurUtil.unBlurMenu(this.idToBlur);
    }
    public sendCreditCardRequest(): void{
        if(this.newCustomer)
            this.sendToNewCustomer();
        else if(this.existingCustomer){
            this.sendToExistingCustomer();
        }
    }

    @HostListener('scroll', ['$event'])
    @HostListener('mousewheel', ['$event'])
    onMousewheel() {
        let delta = document.getElementById("myModal").clientHeight - document.getElementById("myModal").scrollHeight == 0;

        if (delta && !this.isOrderLoading)
            this.loadNextOrders();
    }

    @HostListener('document:keydown', ['$event'])
    onArrowDown(event: any) {
        if (this.isOrderLoading)
            return;

        if (event.keyCode == 38 || event.keyCode == 40)
            this.loadNextOrders();
    }

    public handleScroll(): void {
        this.loadNextOrders();
    }

    public viewAllOrders(): void {
        BlurUtil.unBlurMenu(this.idToBlur);
        this.router.navigate([`management/order`, {
            customeremail: this.currentCustomer.Email,
            customerid: this.currentCustomer.Id
        }]);
    }

    public loadNextOrders(): void {
        if (!this.hasNextOrder)
            return;

        this.isOrderLoading = true;
        this.customerService.getByCustomerId(this.currentCustomer.Id, this.skip, this.top).then(result => {
            this.isOrderLoading = false;

            if (!result || !result.Data)
                return;

            if (result.Data.Items.length == 0)
                this.hasNextOrder = false;

            this.skip += this.top;

            result.Data.Items.sort((x, y) => {
                return new Date(x.Created) > new Date(y.Created) ? -1 : 1;
            });

            for (let o of result.Data.Items) {
                this.currentCustomer.Orders.push(o);
                this.originalCustomer.Orders.push(o);
            }
        })
    }


    public save(isValid: boolean): void {
        if (!isValid)
            return;

        this.processing = true;

        if (!this.isEditMode){
            this.customerService.create(this.currentCustomer).then(response => {
                this.processing = false;
                this.customerSaved.emit(response.Data);
                this.customerModal.hide();
            }).catch(() => {
                this.toastr.error("Failed to create");
                this.processing = false;
            });

            if(this.extraData.ReferenceId != null)
                this.extraDataService.modify(this.extraData);
        } else {
            this.customerService.update(new CustomerModifyRequest({
                Customer: this.currentCustomer,
                ChangeForAllOrders: this.changeCustomersForAll
            })).then(response => {
                this.processing = false;
    
                if (this.changeCustomersForAll)
                    this.toastr.success("Orders were updated");
    
                this.customerSaved.emit(response.Data);
                this.customerModal.hide();
    
            }).catch(() => {
                this.toastr.error("Does not change any order");
                this.processing = false;
            });
    
            this.extraDataService.modify(this.extraData);
        }
    }

    public cancel(): void {
        this.customerModal.hide();
    }

    // TEMP FOR TEST BY TASK https://jira.ak-tech.org/browse/BB-2852
    public sendGetStartedEmail(): void {
        this.isDisabledSendGetStartedEmailButton$.next(true);
        fromPromise(this.emailService.sendGetStartedEmail(this.currentCustomer.Email))
            .pipe(finalize(() => this.isDisabledSendGetStartedEmailButton$.next(false)))
            .subscribe()
    }

    public copyToClipboard(copyToClipboardInput: HTMLInputElement): void
    {
        copyToClipboardInput.select();
        document.execCommand('copy');
        copyToClipboardInput.setSelectionRange(0, copyToClipboardInput.value.length);
        this.toastr.success('Link copied to clipboard.')

        this.isCopied$.next(true);

        const timeoutId = setTimeout(() => {
            this.isCopied$.next(false);
            clearTimeout(timeoutId);
        }, 3000);

    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/customerManagement/modal/customerModal.component.ts